import axios from "@/libs/axios";

export async function aggregate(query) {
    try {
        const { data } = await axios.get("/api/v1/service/aggregate-info", { params: query })
        return { data }
    } catch (error) {
        return { error: error }
    }
}